"use strict";

const TelrResultBmpGeoServerLayer = function () {
  const layerName = "telrResultBmp";
  const layerKey = "telrResultBmpLayer";

  var createMarkerFunction = function (feature, latlng) {
    return L.marker(latlng, {
      icon: createIconFunction(feature),
    });
  };

  var createIconFunction = function (feature) {
    return BmpFcsIcon.getIconMarker(
      feature.properties.bmp_score,
      feature.properties.cbmp,
      feature.properties.bmp_abbrev,
      feature.properties.fcs,
      false,
      feature.properties.phase,
      false,
      false,
      Tree.get("zoomLevel"),
    );
  };

  var getLayerData = async function (onlineFiltering = false, loadingScreen = true) {
    const data = await GeoServerLayerFunctions.getFeaturesForLayer(
      layerName,
      onlineFiltering,
      loadingScreen,
    );

    return organizeLayerData(data);
  };

  var organizeLayerData = function (layerData) {
    return layerData.map(function (data) {
      const properties = data.properties;
      properties.geometry = data.geometry;
      return properties;
    });
  };

  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    const telrResultBmpLayer = new GeoServerMapLayer(layerName, layerKey, createMarkerFunction);
    GeoServerLayerFunctions.setLayerInstanceByMapId(layerName, mapId, telrResultBmpLayer);

    telrResultBmpLayer.loadToggledListenerForMap(map, mapLayers, mapId);
    telrResultBmpLayer.loadTreeUpdateListenersForMap(map, mapLayers, mapId);
  };

  var loadLayer = function (mapId = "main") {
    GeoServerLayerFunctions.loadLayerByMapId(layerName, mapId);
  };

  var invalidateLayerData = function (loadingScreen = true) {
    GeoServerLayerFunctions.invalidateLayerDataForMainMap(layerName, loadingScreen);
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    createMarkerFunction,
    getLayerData,
    invalidateLayerData,
  };
};

module.exports = TelrResultBmpGeoServerLayer();

const GeoServerMapLayer = require("../mapFunctions/geoServerMapLayer");
const BmpFcsIcon = require("../bmpfcs/bmpFcsIcon");
const GeoServerLayerFunctions = require("../mapFunctions/geoServerLayerFunctions");
const Tree = require("../tree");
